const identifierLengths = {
  faustIdentifierLength: 8,
  digitalMaterialIdentifierLength: 13
};

export const { faustIdentifierLength, digitalMaterialIdentifierLength } =
  identifierLengths;
